import { Link } from 'react-router-dom'
import Spinner from './Spinner'

const VARIANTS = {
  primary:
    'bg-white text-[var(--color-indigo-800)] hover:bg-white/90 active:bg-white/80',
  ceremonial:
    'bg-white text-[var(--color-indigo-800)] hover:bg-white/95 cta-glow shadow-[var(--shadow-card)]',
  ghost:
    'bg-transparent text-white hover:bg-white/10 active:bg-white/20',
  outline:
    'bg-transparent text-white border border-white/30 hover:bg-white/10 hover:border-white/50',
}

const SIZES = {
  sm: 'h-9 px-4 text-xs',
  md: 'h-11 px-6 text-sm',
  lg: 'h-14 px-8 text-base',
}

export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  to,
  href,
  type = 'button',
  loading = false,
  disabled = false,
  fullWidth = false,
  className = '',
  ...rest
}) {
  const cls = [
    'inline-flex items-center justify-center gap-2',
    'font-semibold tracking-wider uppercase',
    'rounded-[var(--radius-md)] transition-colors duration-200',
    'disabled:opacity-50 disabled:cursor-not-allowed',
    'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white',
    VARIANTS[variant] || VARIANTS.primary,
    SIZES[size] || SIZES.md,
    fullWidth ? 'w-full' : '',
    className,
  ].join(' ')

  const content = (
    <>
      {loading && <Spinner size={16} />}
      {children}
    </>
  )

  if (to) {
    return (
      <Link to={to} className={cls} aria-disabled={disabled} {...rest}>
        {content}
      </Link>
    )
  }
  if (href) {
    return (
      <a href={href} className={cls} {...rest}>
        {content}
      </a>
    )
  }
  return (
    <button type={type} disabled={disabled || loading} className={cls} {...rest}>
      {content}
    </button>
  )
}
